import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import Checkbox from 'react-toolbox/lib/checkbox';

const Link = glamorous.a(
  {
    textTransform: 'lowercase',
    fontWeight: 'bold',
    fontSize: '1.2rem',
    padding: '0px 0px 16px',
    cursor: 'pointer',
    display: 'inline-block',
    textDecoration: 'underline',
  },
  ({ color }) => {
    return { color };
  }
);

export class ToggleLink extends React.Component {
  static propTypes = {
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ active: PropTypes.string, inactive: PropTypes.string }),
    ]),
    onClick: PropTypes.func,
    active: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    const { active } = props;
    this.state = { active: !!active };
  }

  componentWillUpdate(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({ active: nextProps.active });
    }
  }

  handleOnClick = onClick => () => {
    this.setState(
      prevState => ({ active: !prevState.active }),
      () => {
        return onClick(this.state);
      }
    );
  };

  render() {
    const { active } = this.state;
    const { label, onClick, ...restProps } = this.props;

    let displayLabel = label;
    if (typeof displayLabel === 'object' && label.active && label.inactive) {
      displayLabel = active ? label.active : label.inactive;
    }

    return (
      <Link onClick={this.handleOnClick(onClick)} {...restProps}>
        {displayLabel}
      </Link>
    );
  }
}

export const CheckboxGroup = ({
  onChange,
  disabled,
  value: checklistValue = [],
  children,
  // eslint-disable-next-line no-unused-vars
  error,
  color,
  options,
  ...restProps
}) => {
  return (
    <div {...restProps}>
      {React.Children.map(children, child => {
        let newProps = { color };
        if (child.type === CustomCheckbox || child.type === Checkbox) {
          newProps = {
            ...newProps,
            onChange: value => {
              let newValue;
              if (value) {
                newValue = [...checklistValue, child.props.value];
              } else {
                newValue = checklistValue.reduce((acc, curr) => {
                  if (curr === child.props.value) {
                    return acc;
                  }
                  return [...acc, curr];
                }, []);
              }
              return onChange(newValue);
            },
            disabled,
            checked: checklistValue.includes(child.props.value),
          };
        }
        if (child.type === ToggleLink) {
          newProps = {
            ...newProps,
            onClick: ({ active }) => {
              return active ? onChange(options.map(o => o.text)) : onChange([]);
            },
          };
        }
        return React.cloneElement(child, newProps);
      })}
    </div>
  );
};

const CheckboxGroupContainer = glamorous(CheckboxGroup, {})({
  padding: '1.2rem 1rem',
  '& > label:first-child': {
    marginTop: '1.5rem',
  },
});

const CustomCheckbox = glamorous(Checkbox, {
  rootEl: 'input',
  forwardProps: [
    'checked',
    'children',
    'className',
    'disabled',
    'label',
    'name',
    'onBlur',
    'onChange',
    'onFocus',
  ],
})(({ checked, color }) => {
  let checkedStyle = {};
  if (checked) {
    checkedStyle = {
      borderColor: `${color} !important`,
      backgroundColor: `${color} !important`,
    };
  }
  return {
    '& > div': {
      ...checkedStyle,
      '& > span:last-child > span': {
        backgroundColor: `${color} !important`,
      },
    },
  };
});

export const CheckboxList = ({
  options = [],
  value = [],
  onChange,
  color,
  ...restProps
}) => {
  // allow deselect option when value and options match
  // (i.e. all are manually selected)
  const optionsStrList = options.map(o => o.text);
  const active =
    value.length === optionsStrList.length &&
    optionsStrList.every(o => value.includes(o));

  return (
    <CheckboxGroupContainer
      color={color}
      value={value}
      onChange={onChange}
      options={options}
      {...restProps}
    >
      <ToggleLink
        active={active}
        label={{ active: 'deselect all', inactive: 'select all' }}
      />
      {options.sort((a, b) => a.order - b.order).map(({ text }, i) => {
        if (typeof text !== 'string') {
          return <h4 key={`${text}_${i}`}>Unsupported response type</h4>;
        }
        return (
          <CustomCheckbox key={`${text}_${i}`} label={text} value={text} />
        );
      })}
    </CheckboxGroupContainer>
  );
};

export default CheckboxList;



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/QuestionGroup/InputTypes/CheckboxList/index.js